import React, { createContext, useContext, useState, ReactNode } from 'react';

type User = {
  nome: string;
  cognome: string;
  dataNascita: string;
  cellulare: string;
  email: string;
  barcode: string;
  punti: number;
  [key: string]: any;
};

type AuthContextType = {
  user: User | null;
  setUser: (user: User | null) => void;
};

const AuthContext = createContext<AuthContextType>({
  user: null,
  setUser: () => {},
});

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export { AuthContext };